export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'

export const THEME = 'THEME'
export const POP_UP_PWA = 'POP_UP_PWA'

export const APP_VERSION = "APP_VERSION"
export const USER_DETAIL = "USER_DETAIL"
export const MODAL_HANDLER = "MODAL_HANDLER"
export const CURRENT_COMPANY = "CURRENT_COMPANY"

export const USER_COMPANIES_REQUEST = 'USER_COMPANIES_REQUEST'
export const USER_COMPANIES_SUCCESS = 'USER_COMPANIES_SUCCESS'
export const USER_COMPANIES_FAIL = 'USER_COMPANIES_FAIL'

/* ----- sell ----- */
export const ALL_PRODUCTS = "ALL_PRODUCTS"
export const ALL_USERS = "ALL_USERS"
export const ALL_INVOICE = "ALL_INVOICE"
export const CATH_SUMMERY_DATA = "CATH_SUMMERY_DATA"
export const RESET_SUMMERY_DATA = "RESET_SUMMERY_DATA"
export const RESET_ALL_STATE = "RESET_ALL_STATE"

/* ---- buy ----- */
export const BUY_ALL_PRODUCTS = "BUY_ALL_PRODUCTS"
export const BUY_ALL_USERS = "BUY_ALL_USERS"
export const BUY_ALL_INVOICE = "BUY_ALL_INVOICE"
export const BUY_CATH_SUMMERY_DATA = "BUY_CATH_SUMMERY_DATA"
export const BUY_RESET_SUMMERY_DATA = "BUY_RESET_SUMMERY_DATA"
export const BUY_RESET_ALL_STATE = "BUY_RESET_ALL_STATE"